module.exports = __webpack_public_path__ + "bf.svg?68e2b678a3b0e13034fe5babf6e7397e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bf.svg
// module id = 1196
// module chunks = 27